<template>
  <div id="ticketNote">
    <div class="vo-card">
      <div class="header-small">Notes</div>
      
      <div class="details notes">
        <div class="section" style="margin-bottom: 0;">
          <v-text-field v-model="note.note" ref="inputDescription" type="text" :rules="noteRules.note" label="Description" multi-line no-resize rows="2" maxlength="2000"></v-text-field>
          <v-text-field v-model="note.material" ref="inputMaterials" type="text" :rules="noteRules.material" label="Materials Used" maxlength="200"></v-text-field>
          <div class="small-fields">
            <v-text-field v-model="note.timeTakenHours" ref="inputLabour" :type="numberInputType" :rules="noteRules.number" class="small-input" label="Labour Hours"></v-text-field>
            <v-text-field v-model="note.cost" ref="inputCost" :type="numberInputType" :rules="noteRules.number" class="small-input" label="Cost"></v-text-field>
          </div>
          <v-btn class="save-note" :loading="noteLockout" flat color="primary" @click="createNote">Save Note</v-btn>
          <div class="clear"></div>
        </div>
      </div>
      
      <!-- NOTES LIST -->
      <vo-list v-if="page.ticketNotes.list" class="list" :list="page.ticketNotes.list">
        <div class="note" slot-scope="item" slot="itemSlot">              
          
          <div class="user">
            <div class="avatar">
              <vo-avatar :size="30" :user="$store.getters.user($store.getters.ticketNote(item.item).createdBy)"></vo-avatar>
            </div>
            <div class="name">{{ $store.getters.user($store.getters.ticketNote(item.item).createdBy).fullName }}</div>
            <div class="date">{{ $store.getters.ticketNote(item.item).created | dateTimeShorthand }}</div>
          </div>

          <div class="note-content">
            
            <div class="item" v-if="$store.getters.ticketNote(item.item).note">
              <div class="name">Description</div>
              <div class="value">{{ $store.getters.ticketNote(item.item).note }}</div>
            </div>

            <div class="item" v-if="$store.getters.ticketNote(item.item).material">
              <div class="name">Materials Used</div>
              <div class="value">{{ $store.getters.ticketNote(item.item).material }}</div>
            </div>
            
            <div class="small-fields">
            
              <div v-if="$store.getters.ticketNote(item.item).timeTakenHours" class="small-field">
                <div class="name">Labour Hours</div>
                <div class="value">{{ $store.getters.ticketNote(item.item).timeTakenHours }}</div>
              </div>
            
              <div v-if="$store.getters.ticketNote(item.item).cost" class="small-field">
                <div class="name">Cost</div>
                <div class="value">{{ $store.getters.ticketNote(item.item).cost | money }}</div>
              </div>
              
            </div>
          </div>

        </div>
      </vo-list>

    </div>       
  </div>

</template>

<script>

  export default {
    data () {
      return {

        // NOTE
        noteLockout: false,

        note: {
          note: '',
          material: '',
          timeTakenHours: '',
          cost: ''
        }, 

        timeouts: {
          ticketNotes: false
        },

        noteRules: {

          note: [
            function (e) {
              return (e && e.length > 0 && !window.regex.description.test(e)) ? 'Please enter a valid description.' : true;
            }
          ],
          material: [
            function (e) {
              return (e && e.length > 0 && !window.regex.title.test(e)) ? 'Please enter a valid material list.' : true;
            }
          ],
          number: [
            function (e) {
              return (e && !window.regex.number.test(e) || e && e <= 0) ? 'Please enter a number.' : true;
            }
          ]
        }
      }
    },

    props: {
      
      page: {
        
      }

    },

    methods: {

      // NOTES    
      createNote () {
        if (this.noteLockout) return;
        this.noteLockout = true;
        
        var valid = this.validateNote();
        
        if (!valid) {
          Toast.show('Please correct the highlighted errors.', 'error');
          this.noteLockout = false;
          return;
        }

        if (this.note.note.length === 0 && this.note.material.length === 0 && this.note.timeTakenHours.length === 0 && this.note.cost.length === 0) {
          Toast.show('Please enter a note.', 'error');
          this.noteLockout = false;
          return;
        }

        this.$store.dispatch('createTicketNote', {
          ticket: this.ticket._id,
          property: this.ticket.property,
          note: this.note
        })
        .then(data => {          
          this.resetNote();
          
          this.page.ticketNotes.list.addItem(data._id, {unshift: true});
          Toast.show('Ticket Note created.', 'success');

          this.noteLockout = false;
        })
        .catch(e => {
          console.log(e);
          Toast.showError(e);
          this.noteLockout = false;
        });
      },

      validateNote () {
        this.$refs.inputDescription.validate(true);
        this.$refs.inputMaterials.validate(true);
        this.$refs.inputLabour.validate(true);
        this.$refs.inputCost.validate(true);

        return (this.$refs.inputDescription.valid && this.$refs.inputMaterials.valid && this.$refs.inputLabour.valid && this.$refs.inputCost.valid);
      },


      resetNote () {
        this.note = {
          note: '',
          material: '',
          timeTakenHours: '',
          cost: ''
        }
      },

      initSelected () {
        
        if (!this.selected) return;

        // Reset Note Form
        this.resetNote();

        // Reset Ticket Notes
        if (this.page.ticketNotes.list) this.page.ticketNotes.list.clearList();

        if (this.timeouts.ticketNotes) clearTimeout(this.timeouts.ticketNotes);
        this.timeouts.ticketNotes = setTimeout(() => {

          // Create Ticket Note list
          Vue.set(this.page.ticketNotes, 'list', new ListModel(this.page.ticketNotes.listParams));
          
          // Set Params - Being watched by List.vue, will load itself
          this.page.ticketNotes.list.params = {
            ticket: this.ticket,
            property: this.ticket.property
          };       

        }, window.cordova ? 700 : 1); 
      
      }

    },

    computed: {

      ticket () {
        return this.$store.getters.ticket(this.page.selected);         
      },

      selected () {
        return this.page.selected; 
      },
            
      numberInputType () {
       return (window.cordova && window.cordova.platformId.toLowerCase() === 'ios') ? 'text' : 'number';
      }

    },

    watch: {

      selected () {

        // Since Ticket Note is a child of Ticket Detail, selected will already be defined when the App loads and won't run the watcher the first time a Ticket loads. The watcher will work if we open a 2nd ticket, so we just need to add this logic in the created hook as well.
        
        this.initSelected();
      }

    },

    created () {

      // See watch.selected for details
      this.initSelected();
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #ticketNote {
    
    .vo-card {

      .header {
        position: relative;
        height: 81px;
        width: 100%;
        border-bottom: 1px solid $black12;
      }

      .header-small {
        padding: 16px;
        box-sizing: border-box;
        border-bottom: $borderBlack12;
        @include fontPrimary400;
        @include title();
        font-size: 18px;
      }  

      .details {
        padding: 16px;
        box-sizing: border-box;

        &.notes {
          border-bottom: $borderBlack12;
        }

        .section {
          margin: 0 0 24px;

          .section-title {
            @include fontPrimary500();
    
            text-transform: uppercase;
            color: $black54;
            font-size: 14px;
            letter-spacing: .5px;
            padding: 16px 0 5px;
            border-bottom: 1px solid $black12;
          }

          .title-value {
            margin: 16px 0;
          }
    
          .description {
            font-size: 14px;
          }

          .small-fields {

            text-align: right;

            .small-input {
              width: 140px;
              display: inline-block;
              margin: 0 0 0 16px;
            }

          }

          .save-note {
            float: right;
          }
        }
      }
      
      .note {
        
        position: relative;
        margin: 0 auto;
        width: calc(100% - 64px);
        padding: 24px 0;
        box-sizing: border-box;
        border-bottom: $borderBlack12;

        .user {
          position: relative;
          height: 60px;
          margin: 0 0 12px;

          .avatar {
            position: absolute;
            left: 0;
            top: 16px;
          }
    
          .name {
            position: absolute;
            left: 44px;
            top: 12px;
            right: 16px;
    
            @include fontPrimary400;
            @include textEllipsis;

            color: $black87;
            font-size: 16px;
          }

          .date {
            @include fontPrimary300;
            @include textEllipsis;

            position: absolute;
            right: 16px;
            top: 34px;
            left: 44px;

            font-size: 12px;
            color: $black54;
          }
        }

        .note-content {
          margin: 0 0 0 44px;
        
          .name {
            font-size: 12px;
            color: $black54;
            margin: 0 0 4px;
          }

          .value {
            font-size: 14px;
            color: $black87;
            margin: 0 0 10px;
          }

          .small-fields {
            
            margin: 12px 0 0;
            text-align: right;

            .small-field {
              display: inline-block;
              text-align: right;
              margin: 0 0 0 16px;
            }
          }
        }
      }

    }
  }

</style>


// WEBPACK FOOTER //
// src/components/TicketNote.vue